import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["onSubmit"]

import { IonAlert, IonLoading, useIonRouter, IonGrid, IonRow, IonLabel, IonButton, IonInput, IonSelect, IonSelectOption, IonItem, IonCheckbox } from '@ionic/vue';
import { onUnmounted, ref } from 'vue';
import { Configuration, MobileApiFactory, RegisterRequest } from "plate-vision-demo-openapi-client";
import { Storage } from '@ionic/storage';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'SignIn',
  setup(__props) {

const { t } = useI18n({
      inheritLocale: true,
      useScope: 'global'
})

function onClickDetectsMakeModel (bool: boolean){
    form.value.toDetectMakeAndModel = bool;
}

const tc = ref<boolean>(false);
const mobileApi = MobileApiFactory(new Configuration({basePath: process.env.VUE_APP_PATH}));

const form = ref<RegisterRequest>({
    email: "",
    name: "",
    plateLocation: "",
    toDetectMakeAndModel: false,
    companyName: ""
});

const router = useIonRouter();

async function register(){
    isLoading.value = true
    mobileApi.register(form.value).then((response) => {
        const storage = new Storage();
        storage.create().then(() => {
            storage.set('token', response.data.token).then(() => {
                storage.set('detect', form.value.toDetectMakeAndModel).then(() => {
                    storage.set('plateLocation', form.value.plateLocation).then(() => {
                        router.push({name:"emailConfirm"});
                    });
                });
            });
        });
    }).catch(() => {
        isLoading.value = false
        showErrorConnection.value = true
    })
} 

onUnmounted(() => {
    isLoading.value = false;
})

const isLoading = ref(false);
const showErrorConnection = ref(false);


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonAlert), {
      "is-open": showErrorConnection.value,
      header: _unref(t)('homepage.alertHeader'),
      subHeader: _unref(t)('homepage.alertSubHeader'),
      message: _unref(t)('homepage.alertMessage'),
      buttons: ['OK'],
      onDidDismiss: _cache[0] || (_cache[0] = ($event: any) => (!showErrorConnection.value))
    }, null, 8, ["is-open", "header", "subHeader", "message"]),
    _createElementVNode("form", {
      onSubmit: _withModifiers(register, ["prevent"]),
      class: "margin-1-rem-tb bradius12"
    }, [
      _createVNode(_unref(IonItem), { style: {"margin-top":"1rem","border-radius":"12px 12px 0 0"} }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonLabel), { position: "floating" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('signIn.name')) + "* ", 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(IonInput), {
            "clear-input": true,
            name: "name",
            required: "",
            modelValue: form.value.name,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.name) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_unref(IonItem), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonLabel), { position: "floating" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('signIn.email')) + "* ", 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(IonInput), {
            "clear-input": true,
            name: "email",
            type: "email",
            required: "",
            modelValue: form.value.email,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.email) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_unref(IonItem), { style: {"border-radius":"0 0 12px 12px"} }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonLabel), { position: "floating" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('signIn.company')), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(IonInput), {
            "clear-input": true,
            name: "company",
            modelValue: form.value.companyName,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.companyName) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_unref(IonItem), { class: "margin-1-rem-tb bradius12" }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonLabel), null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('preferencesPage.where')) + "* ", 1),
              _createVNode(_unref(IonSelect), {
                interface: "popover",
                placeholder: _unref(t)('signIn.placeholderContinent'),
                modelValue: form.value.plateLocation,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.plateLocation) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonSelectOption), { value: "eu" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('preferencesPage.eu')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonSelectOption), { value: "na" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('preferencesPage.na')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonSelectOption), { value: "ca" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('preferencesPage.ca')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonSelectOption), { value: "sa" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('preferencesPage.sa')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonSelectOption), { value: "other" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('preferencesPage.other')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["placeholder", "modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonItem), { class: "margin-1-rem-tb bradius12" }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonGrid), {
            fixed: true,
            style: {"padding":"1rem 0"}
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonRow), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonLabel), null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('preferencesPage.licenseOption')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonRow), { style: {"padding":"1rem 0 0.5rem"} }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonItem), {
                    expand: "block",
                    class: "customButton",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (onClickDetectsMakeModel(false))),
                    color: !form.value.toDetectMakeAndModel? 'primary' : 'light'
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, _toDisplayString(_unref(t)('preferencesPage.plateOnly')), 1)
                    ]),
                    _: 1
                  }, 8, ["color"])
                ]),
                _: 1
              }),
              _createVNode(_unref(IonRow), { style: {"padding":"0.5rem 0 0"} }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonItem), {
                    expand: "block",
                    class: "customButton",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (onClickDetectsMakeModel(true))),
                    color: form.value.toDetectMakeAndModel? 'primary' : 'light'
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, _toDisplayString(_unref(t)('preferencesPage.plateAndVehicle')), 1)
                    ]),
                    _: 1
                  }, 8, ["color"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonItem), { class: "margin-1-rem-tb bradius12" }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonCheckbox), {
            required: "",
            modelValue: tc.value,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((tc).value = $event))
          }, null, 8, ["modelValue"]),
          _createVNode(_unref(IonLabel), { style: {"padding-left":"1rem"} }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('termsConditions.accept')) + " ", 1),
              _createVNode(_component_router_link, { to: {name: 'terms'} }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('termsConditions.title').toLowerCase()) + "*", 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonButton), {
        shape: "round",
        class: "max-width-button",
        size: "large",
        expand: "block",
        type: "submit",
        disabled: !tc.value || !form.value.plateLocation
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('signIn.register')), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ], 40, _hoisted_1),
    _createVNode(_unref(IonLoading), {
      "is-open": isLoading.value,
      message: _unref(t)('signIn.saving')
    }, null, 8, ["is-open", "message"])
  ], 64))
}
}

})